import React, { useState } from "react";
import { Link } from "gatsby";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "../styles/bootstrap.min.css";
import "../styles/fontawesome.css";
import "../styles/main.css";
import "../styles/header.css";
import "../styles/element.css";
import "../styles/footer.css";
import "../styles/survey.css";
import "../styles/workshops.css";
import Contact from "../components/contact";

const Header = ({lang}) => {
  const [isDropdown, setIsDropdown] = useState(false);
  const [isOpenContact, setOpenContact] = useState(false);

  return (
    <>
      <div className="container desktop_res mt-2">
        {/* <a className="navbar-brand logo_header" href="https://online.berjayasompo.com.my/"> */}
        <div className="navbar-brand logo_header">
          <img
            className="d-block w-100 img-fluid"
            src={"/securemotor/images/sompo_cimb_logo_new.png"}
            alt="logo"
          />
          {/* </a> */}
        </div>
        <div className="prod-name_right mt-3">Secure Motor</div>
      </div>

      <nav className="navbar navbar-expand-lg mobile_res">
        <div className="container line-bottom online-menu_pad">
          <div className="navbar-brand logo_header">
            {/* <a className="navbar-brand logo_header" href="https://online.berjayasompo.com.my/"> */}
            <img
              className="d-block w-100 img-fluid"
              src={"/securemotor/images/sompo_cimb_logo_new.png"}
              alt="logo"
            />
            {/* </a> */}
          </div>
          <button
            className="navbar-toggler navbar-toggler-right mobile"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item mobile"></li>
              <li className="nav-item mobile">
                <Link className="nav-link" to={lang.header.url}>
                  {lang.header.home}
                </Link>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href="/securemotor/HowtoMakeMotorClaims"
                //   target="_blank"
                  rel="noreferrer"
                >
                  {lang.header.how_to_claim}
                </a>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href="/securemotor/authorised-panel-workshops"
                //   target="_blank"
                  rel="noreferrer"
                >
                  {lang.header.authorised_panel_workshops}
                </a>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href="/securemotor/esi-motor-claims"
                //   target="_blank"
                  rel="noreferrer"
                >
                  {lang.header.esi_motor_claims}
                </a>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link"
                  href="#"
                  onClick={() => setOpenContact((v) => !v)}
                >
                  {lang.header.contact_us}
                </a>
              </li>
              <li className="nav-item mobile">
                <a
                  className="nav-link no-line"
                  href="https://travel.berjayasompo.com.my/travel-insurance/highlights/partner.html"
                >
                  {lang.header.partner_with_us}
                </a>
              </li>

              <li class="nav-item dropdown hidden">
                <a
                  class="nav-link dropdown-toggle bold"
                  href="#"
                  id="navbarDropdownPortfolio"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {lang.header.online_products}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdownPortfolio"
                >
                  <a
                    class="dropdown-item"
                    href="https://travel.berjayasompo.com.my/TravelSafe/agentIndex?agentid=HQ8180004"
                    target="_blank"
                  >
                    Secure TravelSafe
                  </a>
                  <a
                    class="dropdown-item"
                    href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/"
                    target="_blank"
                  >
                    Secure Home
                  </a>
                  <a
                    class="dropdown-item"
                    href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Medz"
                    target="_blank"
                  >
                    Snatch Medz+
                  </a>
                  <a
                    class="dropdown-item"
                    href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Shield"
                    target="_blank"
                  >
                    Snatch Shield Plus
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <ul className="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle bold online-menu_pad2"
              href="#"
              id="navbarDropdownPortfolio"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Online Products
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbarDropdownPortfolio"
            >
              <a
                class="dropdown-item"
                href="https://travel.berjayasompo.com.my/TravelSafe/agentIndex?agentid=HQ8180004"
                target="_blank"
              >
                Secure TravelSafe
              </a>
              <a
                class="dropdown-item"
                href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/"
                target="_blank"
              >
                Secure Home
              </a>
              <a
                class="dropdown-item"
                href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Medz"
                target="_blank"
              >
                Snatch Medz+
              </a>
              <a
                class="dropdown-item"
                href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Shield"
                target="_blank"
              >
                Snatch Shield Plus
              </a>
            </div>
          </li>
        </ul>
      </nav>

      <div className="text-right header_element"></div>

      <div className="bread_navi_bg desktop_res">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-9 col-md-8">
              <nav role="navigation" className="bread_navi">
                <ul>
                  <li>
                    <Link to={lang.header.url}>
                      {lang.header.home}
                    </Link>
                  </li>
                  <li>
                    <a
                      href="/securemotor/HowtoMakeMotorClaims"
                    //   target="_blank"
                      rel="noreferrer"
                    >
                      {lang.header.how_to_claim}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/securemotor/authorised-panel-workshops"
                    //   target="_blank"
                      rel="noreferrer"
                    >
                      {lang.header.authorised_panel_workshops}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/securemotor/esi-motor-claims"
                    //   target="_blank"
                      rel="noreferrer"
                    >
                      {lang.header.esi_motor_claims}
                    </a>
                  </li>
                  <li>
                    <a to="#" onClick={() => setOpenContact((v) => !v)}>
                    {lang.header.contact_us}
                    </a>
                  </li>
                  {/* <li>
							<a 
								href="https://travel.berjayasompo.com.my/travel-insurance/highlights/partner.html"
								target="_blank"
								rel="noreferrer"
							>
							{lang.header.partner_with_us}
							</a>
							</li> */}
                </ul>
              </nav>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4">
              <nav className="navbar navbar-expand-lg">
                <div>
                  <ul className="navbar-nav ml-auto">
                    <Dropdown
                      nav={true}
                      isOpen={isDropdown}
                      toggle={() => setIsDropdown((prevState) => !prevState)}
                    >
                      <DropdownToggle
                        className="navbar-nav_desk"
                        caret
                        tag="a"
                        nav={true}
                        href="#"
                      >
                        {lang.header.online_products}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem href="https://travel.berjayasompo.com.my/TravelSafe/agentIndex?agentid=HQ8180004" target="_blank">
                          Secure TravelSafe
                        </DropdownItem>
                        {/* <DropdownItem className="hidden" href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/"> */}
                        <DropdownItem href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/" target="_blank">
                          Secure Home
                        </DropdownItem>
                        <DropdownItem href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Medz" target="_blank">
                          Snatch Medz+
                        </DropdownItem>
                        <DropdownItem href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Shield" target="_blank">
                          Snatch Shield Plus
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Contact
        isOpen={isOpenContact}
        lang={lang}
        toggle={() => setOpenContact((v) => !v)}
      />
    </>
  );
};

export default Header;
